import { render, staticRenderFns } from "./sswg-modal.vue?vue&type=template&id=1e55d96b&scoped=true"
import script from "./sswg-modal.vue?vue&type=script&lang=js"
export * from "./sswg-modal.vue?vue&type=script&lang=js"
import style0 from "./sswg-modal.vue?vue&type=style&index=0&id=1e55d96b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e55d96b",
  null
  
)

export default component.exports